import { CameraTypes } from '../enum/CameraTypes'

export const cameraServerTypesAbleToBeVerified = [CameraTypes.HIKVISION_RTSP]
